<script setup>

const { locale } = useI18n()
const url = useRequestURL()
const sizerCookie = useCookie('sizerCookie')

const { data: pageInit } = await useAPIFetch('Articles')
const list = pageInit.value.body.find(item => item.specific === 'ArticleList')

list.params.orderBy = 'published'

const componentId = ref(list.id)
const isLoading = ref(false)
const limit = ref(list.params.limit || sizerCookie.value * 3 || 12)

const { data: page } = await useAPIFetch(`Articles/component/${componentId.value}`, {
	query: {
		'limit': limit.value,
		'orderBy': 'published'
	}
})

const cursor = ref(page.value.cursor)
let items = ref(page.value.items)

const sortValue = ref(null)
const filterValue = ref(null)

const updateSort = (value) => {
	sortValue.value = value
	updateList()
}

const updateFilter = (value) => {
	let filterParts = []
	value.forEach(item => {
		filterParts.push(`${item.parameter}:${item.value.key}`)
	});

	filterValue.value = filterParts.join('|')

	updateList()
}

const resetFilter = () => {
	filterValue.value = null
	updateList()
}

const loadMore = async () => {
	updateList(true)
}

const updateList = async (loadMore = false) => {
	isLoading.value = true

	let params = {}
	if (sortValue.value) params.orderBy = sortValue.value
	if (filterValue.value) params.filter = filterValue.value

	const result = await useUIFetch(locale.value, `Articles/component/${componentId.value}`, {
		'cursor': loadMore ? cursor.value : null,
		'limit': limit.value,
		...params
	})
	if (loadMore) {
		items.value = [...items.value, ...result.items]
	} else {
		items.value = [...result.items]
	}
	cursor.value = result.cursor
	isLoading.value = false
}

const changeLimit = (value) => {
	limit.value = parseInt(value)
	updateList()
}

useHead({
	bodyAttrs: {
		class: 'has-sizer'
	}
})

useHeadData({
  title: pageInit.value.meta.title,
  description: pageInit.value.meta.description,
	author: pageInit.value.meta.author,
	copyright: pageInit.value.meta.copyright,
	keywords: pageInit.value.meta.keywords,
	og: pageInit.value.meta.og,
	url: url.href
})

</script>

<template>
	<div>
		<div class="container">
			<div class="md:flex justify-between">
				<h1 class="text-red mb-4 md:mb-0">{{ pageInit.attrs.title }}</h1>
				<Filter v-if="list.filter && Object.keys(list.filterProperties)?.length" @update:sort="updateSort" @update:filter="updateFilter" @reset:filter="resetFilter" color="red" :defaultOrder="list.params.orderBy" :orderOptions="list.orderBy || []" :filterProperties="list.filter ? list.filterProperties : null" />
			</div>
		</div>
		<Grid @loadMore="loadMore" @changeLimit="changeLimit" :covers="items" :cursor="cursor?.toString()" :loading="isLoading" />
	</div>
</template>